export const SET_MENU_ITEM_CONFIGURATION = 'SET_MENU_ITEM_CONFIGURATION';
export const SET_MENU_ITEM_COMPONENT = 'SET_MENU_ITEM_COMPONENT';
export const SET_MENU_ITEM_TOPPING = 'SET_MENU_ITEM_TOPPING';
export const SET_MENU_ITEM_SIZE = 'SET_MENU_ITEM_SIZE';
export const RESET_MENU_ITEM_CONFIGURATION = 'RESET_MENU_ITEM_CONFIGURATION';
export const SET_MENU_SCROLL_POSITION = 'SET_MENU_SCROLL_POSITION';
export const TRANSFER_MENU_CONFIGURATION = 'TRANSFER_MENU_CONFIGURATION';
